module.exports = __webpack_public_path__ + "static/media/iwin-1.848a5d42.jpg";